const isDebug = process.env.NODE_ENV !== 'production'

export const actions = {
  async nuxtServerInit({dispatch}) {
    // console.log('nuxtServerInited')
    // await dispatch('modules/prices/fetchPrices')
    // await dispatch('modules/prices/fetchVmwarePrices')
  }
}

export const strict = isDebug